import type { GetStaticPaths } from 'next'
import { PostOrderByInput } from 'src/types/hygraph'
import { HygraphTopics, IBlogPillar, getPosts } from 'src/utils/hygraph'
import Page, { createGetStaticProps } from '../../[pillar]/blog/[slug]'

export default Page

type IParams = { pillar: IBlogPillar; slug: string }

export const getStaticPaths = (async ({ locales = [] }) => {
  const paths: { params: IParams; locale: string }[] = []

  const res = await getPosts(1000, 0, PostOrderByInput.PublishedAtDesc, {
    topic: HygraphTopics.BlogHost,
    listOnly: true
  })
  const pillar = 'anfitrion' as IBlogPillar

  for (const locale of locales) {
    for (const { slug } of res.data?.posts ?? []) {
      paths.push({
        params: { slug: slug as string, pillar },
        locale
      })
    }
  }

  return { paths, fallback: 'blocking' }
}) satisfies GetStaticPaths

// Fallback renders here get only `{ slug }` in params — pin the pillar so the
// canonical-pillar redirect doesn't loop.
export const getStaticProps = createGetStaticProps('anfitrion')
